module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-1.a48551a0.png";